// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { xScreen } from "@stoneage/XDL/Utilities";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

interface MyAccountOrderTopSectionLayoutStyles {
    container?: InjectableCss;
    containerLeftSection?: InjectableCss;
    containerRightSection?: InjectableCss;
}

const myAccountOrderTopSectionLayout: MyAccountOrderTopSectionLayoutStyles = {
    container: {
        css: css`
            display: flex;
            ${xScreen("lte", "md")} {
                flex-direction: column;
            }
            @media print {
                display: block;
            }
        `,
    },
    containerLeftSection: {
        css: css`
            width: calc(100% - 300px);
            padding-right: 22px;
            ${xScreen("lte", "md")} {
                width: 100%;
                padding-right: 0;
            }
        `,
    },
    containerRightSection: {
        css: css`
            max-width: 300px;
            ${xScreen("lte", "md")} {
                max-width: 100%;
            }
        `,
    },
};

const styles = myAccountOrderTopSectionLayout;
const MyAccountOrderTopSectionLayout: FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.containerLeftSection}>
                <Zone contentId={id} zoneName="Content00" />
            </StyledWrapper>
            <StyledWrapper {...styles.containerRightSection}>
                <Zone contentId={id} zoneName="Content01" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: MyAccountOrderTopSectionLayout,
    definition: {
        group: "XNGAGE" as any,
        displayName: "MyAccount Order Top Section layout",
    },
};

export default widgetModule;
